import type { Components, Theme } from '@mui/material';

import { colors } from '../tokens';

export const MuiSelect: Components<Theme>['MuiSelect'] = {
  styleOverrides: {
    select: ({ theme }) => ({
      padding: theme.spacing(1, 4, 1, 1.5),
      fontSize: theme.typography.pxToRem(16),
      lineHeight: theme.spacing(3),
      color: colors.black[950],

      '&.Mui-disabled': {
        color: colors.black[300],
        WebkitTextFillColor: colors.black[300],
        cursor: 'not-allowed',
        ...theme.applyStyles('dark', {
          color: colors.black[600],
          WebkitTextFillColor: colors.black[600],
        }),
      },

      ...theme.applyStyles('dark', {
        color: colors.black[25],
      }),
    }),
  },
};
